import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=57797dd0&scoped=true&slot-scope=message&"
import script from "./alert.js?vue&type=script&lang=js&"
export * from "./alert.js?vue&type=script&lang=js&"
import style0 from "./alert.scss?vue&type=style&index=0&id=57797dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57797dd0",
  null
  
)

export default component.exports